export interface CanvasBounds {
  left: number;
  top: number;
  width: number;
  height: number;
}

export function canvasPointToArena(
  clientX: number,
  clientY: number,
  bounds: CanvasBounds,
  arenaWidth: number,
  arenaHeight: number,
  padding = 24,
): { x: number; y: number } {
  const x = ((clientX - bounds.left) / Math.max(1, bounds.width)) * arenaWidth;
  const y = ((clientY - bounds.top) / Math.max(1, bounds.height)) * arenaHeight;
  return {
    x: Math.max(padding, Math.min(arenaWidth - padding, x)),
    y: Math.max(padding, Math.min(arenaHeight - padding, y)),
  };
}

export function touchDragDirection(
  dx: number,
  dy: number,
  deadZone = 12,
  fullStrengthDistance = 64,
): { x: number; y: number } | null {
  const distance = Math.hypot(dx, dy);
  if (distance < deadZone) return null;
  const strength = Math.min(1, distance / Math.max(deadZone, fullStrengthDistance));
  return {
    x: (dx / distance) * strength,
    y: (dy / distance) * strength,
  };
}

export function viewportPointToWorld(
  point: { x: number; y: number },
  cameraX: number,
  cameraY: number,
  arenaWidth: number,
  arenaHeight: number,
  padding = 24,
): { x: number; y: number } {
  return {
    x: Math.max(
      padding,
      Math.min(arenaWidth - padding, cameraX + point.x),
    ),
    y: Math.max(
      padding,
      Math.min(arenaHeight - padding, cameraY + point.y),
    ),
  };
}
